import { DateTime } from "luxon";

export function getPresetsForSingleDates() {
  const now = DateTime.now();
  const thisMonthStart = now.startOf("month").toISODate();
  const thisMonthEnd = now.endOf("month").toISODate();

  return [
    { value: thisMonthStart, label: "This Month (Start)" },
    { value: now.toISODate(), label: "Today" },
    { value: thisMonthEnd, label: "This Month (End)" },
  ];
}

export function getPresetsForMultipleDates(startDateISO, endDateISO) {
  if (!startDateISO?.trim() || !endDateISO?.trim() || endDateISO < startDateISO) {
    return [];
  }

  const startDate = DateTime.fromISO(startDateISO).startOf("day");
  const endDate = DateTime.fromISO(endDateISO).startOf("day");

  if (!startDate.isValid || !endDate.isValid) {
    return [];
  }

  const weekends = getWeekendDays(startDate, endDate);
  const workDays = getWorkDays(startDate, endDate);
  const allDays = getAllDays(startDate, endDate);

  return [
    { value: weekends, label: "Weekends" },
    { value: workDays, label: "Work Days" },
    { value: allDays, label: "All" },
  ];
}

function getWeekendDays(currentDate, endDate) {
  const weekends = [];

  while (currentDate <= endDate) {
    if ([6, 7].includes(currentDate.weekday)) {
      weekends.push(currentDate.toISODate());
    }

    currentDate = currentDate.plus({ days: 1 });
  }

  return weekends;
}

function getWorkDays(currentDate, endDate) {
  const workDays = [];

  while (currentDate <= endDate) {
    if ([1, 2, 3, 4, 5].includes(currentDate.weekday)) {
      workDays.push(currentDate.toISODate());
    }

    currentDate = currentDate.plus({ days: 1 });
  }

  return workDays;
}

function getAllDays(currentDate, endDate) {
  const workDays = [];

  while (currentDate <= endDate) {
    workDays.push(currentDate.toISODate());
    currentDate = currentDate.plus({ days: 1 });
  }

  return workDays;
}
